import { createContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import api from "../utils/axiosConfig";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Vérifie la session via le cookie HttpOnly (pas de localStorage)
  const checkAuthStatus = async () => {
    try {
      const response = await api.get("/api/auth/show-profile");
      setUser(response.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    try {
      // Le serveur pose le cookie HttpOnly - pas besoin de stocker le token
      await api.post("/api/auth/login", { email, password });
      const profileRes = await api.get("/api/auth/show-profile");
      setUser(profileRes.data);
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      const message =
        status === 401
          ? detail || "Email ou mot de passe incorrect."
          : status === 403
          ? detail || "Accès refusé."
          : status === 429
          ? detail || "Trop de tentatives. Veuillez réessayer plus tard."
          : "Une erreur est survenue. Veuillez réessayer.";
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await api.post("/api/auth/logout");
    } catch {
      // Le cookie sera de toute façon supprimé côté serveur
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
